module.exports = __webpack_public_path__ + "static/media/love-icon-white-hollow.2e59118c.svg";